import React from 'react';
// Import the CSS for styling

const WhatsAppButton = () => {
  const phoneNumber = '917999269342'; // Replace with your phone number in international format
  const message = 'Hi, I would like to learn more about your services!'; // Custom message

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
      <button className='custom-btn btn-3'>
        request a Quatation
      </button>
    </a>
  );
};

export default WhatsAppButton;
